import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import WorkAreaItem from 'modules/locations/components/WorkAreaItem'
import { WorkAreaNodes } from 'modules/locations/hooks/useWorkArea'
import { WorkAreaMapsById } from 'modules/space_control/hooks/useWorkAreaMaps'
import { useWorkSpaces } from 'modules/space_control/hooks/useWorkSpaces'

interface PropsWorkArea {
  locationId: number
  unarchiveWorkAreas: NonNullable<WorkAreaNodes>[]
  workAreaMapsById: WorkAreaMapsById
}

const WorkAreasItem = ({ locationId, unarchiveWorkAreas, workAreaMapsById }: PropsWorkArea) => {
  const { workSpaces } = useWorkSpaces({ locationIds: [locationId] })
  const workAreas = unarchiveWorkAreas.map((workArea) => {
    const workSpacesbyWorkArea = workSpaces.filter(
      (workspace) => workspace.workArea?.id === workArea.id
    )
    return (
      <WorkAreaItem
        workArea={workArea}
        key={`${workArea.id}${workArea.name}`}
        locationId={locationId}
        workSpaces={workSpacesbyWorkArea}
        workAreaMap={workAreaMapsById[workArea.id]}
      />
    )
  })
  return (
    <Box paddingBottom="s24" gap="s24">
      {workAreas}
    </Box>
  )
}

export default observer(WorkAreasItem)
